import { render, staticRenderFns } from "./QuestionnaireAnswerBreakdownDoughnutChart.vue?vue&type=template&id=4b8076ac&"
import script from "./QuestionnaireAnswerBreakdownDoughnutChart.vue?vue&type=script&lang=ts&"
export * from "./QuestionnaireAnswerBreakdownDoughnutChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports